<app-loader></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>
@if (sound) {
  <audio [src]="sound" autoplay style="opacity: 0; visibility: hidden; position: absolute; pointer-events: none;" (ended)="sound = undefined"></audio>
}
